<template>
<aside class="conversations">
  <messaging-bar v-if="show">
    <text-field placeholder="Keyword" />
  </messaging-bar>
  <div class="previews">
    <conversation-row v-for="conversation in conversations"
      :conversation="conversation" :key="conversation.id"
      :class="{ active: isActive(conversation) }"
      v-on:click="onClick(conversation)" />
  </div>
</aside>
</template>

<script>
import TextField from '@/components/general/text-field'
import ConversationRow from '@/components/messaging/conversation-row'
import MessagingBar from '@/components/messaging/messaging-bar'
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      show: false
    }
  },
  components: {
    TextField, ConversationRow, MessagingBar
  },
  computed: {
    ...mapState('conversations', [
      'conversations',
      'currentConversation'
    ])
  },
  methods: {
    ...mapActions('conversations', [
      'getConversations'
    ]),
    isActive (conversation) {
      if (!this.currentConversation) { return false }
      return this.currentConversation.id === conversation.id
    },
    onClick (conversation) {
      this.$router.push(`/messages/${conversation.id}`)
    }
  },
  async mounted () {
    await this.getConversations()
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.conversation-row {
  cursor: pointer;
  &:hover {
    background-color: $hover-background;
  }

  &.active {
    background-color: $hover-background;
  }
}

.conversation-row:not(:first-child) {
  border-top: 1px solid $border-color;
}

.conversation-row:last-child {
  border-bottom: 1px solid $border-color;
}

aside {
  border-left: 0px solid $border-color;
  border-right: 1px solid $border-color;
  height: 100vh;
  background-color: #f9f9f9;
  margin-bottom: -1rem;
  right: 30%;
}

.previews {
  overflow-y: auto;
  height: 100vh;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/messaging/conversations.vue